<template>
  <div class="footer">
    <div class="w-main footer-box">
      <div class="footer-box-list">
        <div class="list">
          <div class="list-title">关于我们</div>
          <div class="item">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page1' },
              }"
              tag="a"
            >
              学会简介
            </router-link>
          </div>
          <div class="item">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page2' },
              }"
              tag="a"
            >
              学会荣誉
            </router-link>
          </div>
          <div class="item">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page3' },
              }"
              tag="a"
            >
              大事记
            </router-link>
          </div>
          <div class="item">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page4' },
              }"
              tag="a"
            >
              理事会成员
            </router-link>
          </div>
          <div class="item">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page5' },
              }"
              tag="a"
            >
              学会章程
            </router-link>
          </div>
        </div>
        <div class="list">
          <div class="list-title">友情链接</div>
          <div class="item">
            <a :href="`http://www.sast.gov.cn/`" class="item-a"
              >上海市科学技术协会</a
            >
          </div>
          <div class="item">
            <a :href="`http://www.cinnet.cn/`" class="item-a">中国航海学会</a>
          </div>
          <div class="item">
            <a :href="`https://www.sh.msa.gov.cn/`" class="item-a"
              >中华人民共和国上海海事局</a
            >
          </div>
          <div class="item">
            <a
              :href="
                `http://www.shanghai.gov.cn/nw2/nw2314/nw2319/nw32905/nw32914/nw32994/nw33008/nw39940/index.html`
              "
              class="item-a"
              >上海市交通委员会</a
            >
          </div>
          <div class="item">
            <a :href="`https://www.ccs.org.cn/ccswz/`" class="item-a"
              >中国船级社上海分社</a
            >
          </div>
          <div class="item">
            <a :href="`http://sh.coscoshipping.com/`" class="item-a"
              >中远海运上海有限公司</a
            >
          </div>
        </div>
        <div class="list">
          <div class="list-title">联系我们</div>
          <div class="item">
            <a>电话：021-65434092</a>
          </div>
          <div class="item">
            <a>邮箱：navigation1978@163.com</a>
          </div>
          <div class="item">
            <a>地址：上海市高阳路147号405室</a>
          </div>
        </div>
      </div>
      <div class="footer-box-code">
        <div class="footer-logo">
          <el-image :src="img.logo" fit="fill"></el-image>
        </div>
        <div class="footer-code">
          <el-image :src="img.code" fit="fill"></el-image>
        </div>
        <p>微信公众号</p>
      </div>
    </div>
    <div class="footer-link">
      <div class="w-main">
        © 上海市航海学会 2014 All Rights Reserved.
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          style="margin-right:10px"
          >沪ICP备09026231号-1</a
        >
        <img src="./1.png" alt="" />
        <a
          target="_blank"
          href="https://www.beian.gov.cn/portal/index?token=0e847659-119c-4389-bd05-bcd000f57dbe"
          >沪公网安备31022102000194号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img/home/logo_w.png";
import code from "@/assets/img/home/code.png";

export default {
  name: "pcHomeFooter",
  data() {
    return {
      img: {
        logo,
        code,
      },
    };
  },
};
</script>

<style lang="less">
.footer {
  position: relative;
  width: 100%;
  height: 380px;
  background: rgba(22, 81, 148, 1);
  &-box {
    display: flex;
    justify-content: space-between;
    padding-top: 60px;
    &-list {
      display: flex;
      .list {
        margin-right: 80px;
        &-title {
          margin-bottom: 26px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
        .item {
          margin-bottom: 6px;
          a {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            opacity: 0.7;
          }
          .item-a {
            display: inline-block;
            width: 168px;
          }
        }
      }
    }
    &-code {
      .footer-logo,
      .footer-code,
      p {
        text-align: center;
      }
      .footer-logo {
        margin-bottom: 24px;
      }
      .footer-code {
        .el-image {
          width: 117px;
        }
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        opacity: 0.7;
      }
    }
  }
  &-link {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 68px;
    line-height: 68px;
    border-top: 1px solid #0f447f;
    color: rgba(255, 255, 255, 1);
    opacity: 0.7;
    text-align: center;
    a {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      opacity: 0.7;
    }
  }
}
</style>
